import React from 'react';
import _ from 'lodash';
import {Alert} from 'componentLibrary';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {Header, Button, Icon, Dimmer, Loader} from 'semantic-ui-react';

export const SubApplicationCard = ({
  key,
  entityId,
  applicationTitle,
  applicationTypeDesc,
  subApplicantTitle,
  handleChange,
  checked,
  isAddingToAmendment,
  selectedSubApp
}) => isAddingToAmendment ? (
  <FemaGoTable.Row key={key}>
    <FemaGoTable.RadioCell
      id="subApplication"
      name="subApplication"
      handleChange={handleChange}
      options={[
      {label: '', value: entityId}
  ]}
  value={selectedSubApp}
/>
<FemaGoTable.TextCell>{applicationTitle}</FemaGoTable.TextCell>
<FemaGoTable.TextCell>{applicationTypeDesc}</FemaGoTable.TextCell>
<FemaGoTable.TextCell>{subApplicantTitle}</FemaGoTable.TextCell>
</FemaGoTable.Row>) :(
  <FemaGoTable.Row key={key}>
    <FemaGoTable.CheckboxCell
      className="checked"
      title="Checked"
      checked={checked}
      width={1}
      handleChange={() => {
        handleChange(entityId);
      }}
    />
    <FemaGoTable.TextCell>{applicationTitle}</FemaGoTable.TextCell>
    <FemaGoTable.TextCell>{applicationTypeDesc}</FemaGoTable.TextCell>
    <FemaGoTable.TextCell>{subApplicantTitle}</FemaGoTable.TextCell>
  </FemaGoTable.Row>
);

const SubApplicationSearchResultsGrid = ({
  data,
  getApplicationTypeLabel,
  searchAgain,
  handleChange,
  handleAddSubApplication,
  categorySelect,
  categoryType,
  subAppAlreadyLinked,
  isAddingToAmendment,  
  selectedSubApp,
  showError,
  addingSubApp
}) => {
  const disabled =
    !data ||
    data.length === 0 ||
    (categorySelect && !categoryType) ||
    (categorySelect && _.filter(data, (application) => application.checked).length === 0) ||
    (!categorySelect && !selectedSubApp);

  const grid = _.map(data, (row, index) => {
    return (
      <SubApplicationCard
        {...row}
        key={index}
        handleChange={handleChange}
        applicationTypeDesc={getApplicationTypeLabel(row.applicationType)}
        selectedSubApp={selectedSubApp}
        isAddingToAmendment={isAddingToAmendment}
      />
    );
  });

  return (
    <React.Fragment>
      {addingSubApp && (
            <Dimmer active page>
              <Loader>Adding subapplication...</Loader>
            </Dimmer>
          )}
      <Header as="h3">Select the subapplication(s) you would like to add</Header>
      <br />
      <div className="sub_application_table">
        <FemaGoTable type="dynamic" scrollable={120}>
          <FemaGoTable.Header>
            <FemaGoTable.Row>
              <FemaGoTable.HeaderCell>Select</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Subapplication title</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Subapplication type</FemaGoTable.HeaderCell>
              <FemaGoTable.HeaderCell>Subapplicant</FemaGoTable.HeaderCell>
            </FemaGoTable.Row>
          </FemaGoTable.Header>
          <FemaGoTable.Body>{grid}</FemaGoTable.Body>
        </FemaGoTable>
      </div>
      <br />
      {categorySelect ? categorySelect : ''}
      <br />
      <Button
        primary
        icon
        id="addSubApplicationButton"
        title="Yes, add subapplication(s)"
        onClick={() => handleAddSubApplication()}
        disabled={disabled}
      >
        {isAddingToAmendment ? 'Yes, add subamendment ' : `Yes, add subapplication(s)  `}
        <Icon name="checkmark" fitted />
      </Button>

      {`  `}

      <a
        id="addSubApplication_tryNewSearch"
        href="#/"
        onClick={(event) => searchAgain(event)}
      >
        <Icon name="undo" />
        No, try a new search
      </a>

      {showError ? (
         <Alert
         size="small"
         header={'Unable to attach the subapplication. Please try again later.  If issue persists please contact FEMAGO helpdesk for further assistance.'}
         type="error"
         dismissable={false}
       >
       </Alert>):''
      }
      {subAppAlreadyLinked ? (
        <Alert size="tiny" type="error" dismissable={false}>
          This subapplication is already linked to another application.
        </Alert>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

export default SubApplicationSearchResultsGrid;